import {
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  TemplateRef, ViewChild
} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {NgForOfContext} from '@angular/common';
import {BaseModel} from '../depends/base.model';
import {isNumberToken} from 'html2canvas/dist/types/css/syntax/parser';
import {TranslateService} from '../translate.service';

@Component({
  selector: 'app-resource-selector',
  templateUrl: './resource-selector.component.html',
  styleUrls: ['./resource-selector.component.css']
})
export class ResourceSelectorComponent<T extends BaseModel> {

    @ViewChild('input', {static: true}) input : ElementRef;

  @Input() control: AbstractControl;
  @Input() displayField: string = null;
  @Input() secondDisplayField: string = null;  // caso o valor do display field seja null, mostra o valor do segundo field  (serve como uma segunda opÃ§Ã£o do que seÃ¡ visualizado)
    @Input() customLabelClass: string = '';

  @Input() set resources(data:T[]) {
    this._resources = data;
    this.filteredResources = this._resources;
    if (this.control && this.control.validator && this.control.validator({} as AbstractControl).required)
      this.canRemoveSelected = false;

      if(!this.setSelectedIfOnly()){
          this.setSelectedResourceFromForm();
      }
  }

  @Input() formOnly : boolean = false;


  @Input() label:string;
  @Input() loading:boolean = false;
  @Input() allowCreation: boolean = false;
  @Input() searchKeys: string[] = [];
  @Input() maxHeight: number = 250;

  @Input() hideRemoveButtonWithOpacity:boolean = false;

  @Input() hideLabel: boolean = false;

  @Input() labelColor : string = '';

  @Input() disabled?: boolean = false;

  @Input() customRenderer: boolean = false;

  @Input() customInputClass : string = '';

  @Input() position: string = 'bottom';

  @Input() searchFunction;

  @Input() setFirstIfOnly = true;

  @Input() canRemoveSelected: boolean = false;
  @Input() removeSelectedMessage: string;

  @Input() translation:boolean = false;

  @Input() hideErrorIcon: boolean = false;

  @Input() allowFreeText: boolean = false;                                                                            // posso usar o selector para auxiliar pra "completar" o valor do campo. PorÃ©m pode ser que a opÃ§Ã£o nÃ£o exista nos resources, entÃ£o o uusÃ¡rio escreve o que eles quiser, sem necessÃ¡riamente ter escolhido um opÃ§Ã£o

  @ContentChild('itemTemplate',{static:false}) itemTemplate: TemplateRef<NgForOfContext<T>>;

  @Output() onCreateButtonPressed: EventEmitter<void> = new EventEmitter<void>();
  @Output() onItemSelected: EventEmitter<T> = new EventEmitter<T>();
  @Output() onSelectionCancelled: EventEmitter<void> = new EventEmitter<void>();

  public filteredResources: T[] = [];
  public selectedResource: T = null;
  private _resources: T[] = [];
  private touched: boolean = false;
  public isInvalid: boolean = false;

  public _displayList: string = 'none';

  divElementFocused: boolean = false;
  inputElementFocused: boolean = false;

  constructor(public translate:TranslateService) { }

  public setSelectedIfOnly(){
    if(this.setFirstIfOnly){
      if(this._resources && this._resources.length == 1){
        this.setSelectedResource(this._resources[0]);
        this.onItemSelected.emit(this._resources[0]);
        return true;
      }
    }
    return false;
  }

    public setSelectedResourceFromForm() {
        if(this.formOnly && this.control != null){
            let value = this.control.value as number;
            if(value != null){
                this.setSelectedResource(value);
                if(this.selectedResource != null){
                    this.onItemSelected.emit(this.selectedResource);
                }
            }
        }
    }

  public setUncreatedResource(value: string){
    let newObj = {} as T;
    newObj.id = -1;
    newObj[this.displayField] = value;

    this._resources.push(newObj);
    this.setSelectedResource(newObj as T);
  }

  public setSelectedResourceByValue(value:string){
    try{
      let item = this._resources.find((resource:T) => resource[this.displayField].toLowerCase() == value.toLowerCase());
      if (item)
        this.setSelectedResource(item as T);
      else
        this.setUncreatedResource(value);
    }catch (e) {
      console.log(e);
      this.cancelSelection();
    }
  }

  public setResources(items:T[]) {
    this._resources = items;
    this.filteredResources = this._resources;
    this.setSelectedIfOnly();
  }

  public setSelectedResource(item:T | number) {
    if(typeof item == 'number'){
      item = this._resources.find((resource:T) => resource.id == item);
    }else{
      item = item as T;
    }

    if(typeof item != 'object' || item == null)
        return

    this.selectedResource = item;
    if(this.control != null)
      this.control.setValue(item.id);

    let input = this.input.nativeElement;
    let inputValue = item[this.displayField];

    if(this.translation)
      inputValue = this.translate.data[inputValue];

    input.value = inputValue;

    if (!item[this.displayField] && this.secondDisplayField)
      input.value = item[this.secondDisplayField];
  }

  public canRemove() : boolean {
    return (this.canRemoveSelected && this.selectedResource != null)
  }

  public cancelSelection() {
    this.selectedResource = null;
    if(this.control != null)
      this.control.patchValue(null);
    this.input.nativeElement.value = null;
    this.onSelectionCancelled.emit();
  }

  public getSelectedresource() : T {
    return this.selectedResource;
  }

  public _filterResources(event): void {

    this.selectedResource = null;

    let searchTerm : string = event.target.value;
    let searchCriteria : string[] = this.searchKeys;

    if(searchCriteria.length == 0){
      searchCriteria = [this.displayField];
    }

    if (this.searchFunction) {
      this.searchFunction(searchTerm);
    } else if (searchTerm != '' && searchTerm != null) {
      searchTerm = searchTerm.toUpperCase();
      this.filteredResources = this._resources.filter((resource:T) => this.filterResource(resource,searchCriteria,searchTerm));
    } else {
      this.filteredResources = this._resources;
    }
  }

  private filterResource(resource:T,searchCriteria:string[],searchTerm:string) : boolean {
    for (let i = 0; i < searchCriteria.length; i++){
      let searchable = resource[searchCriteria[i]];
      if(searchable != null){
        searchable = searchable.toString().toUpperCase();
        if(searchable.indexOf(searchTerm) != -1)
          return true;
      }
    }
    return false;
  }

  public isValid() : boolean {

    if(this.control == null)
      return true;

    let valid = !(this.control.invalid && this.touched);

    if(valid && this.control.validator && this.control.validator({} as AbstractControl).required ){
      if(this.touched && this.selectedResource == null){
        valid = false;
      }
    }
    return valid;
  }

  emitNewItemButtonPressed(){
    this.onCreateButtonPressed.emit();
  }

  public showList(element: string) {
      if (!this.disabled) {
          if (element == 'div')
              this.divElementFocused = true;
          else if (element == 'input')
              this.inputElementFocused = true;

          this._displayList = 'flex';
      }
  }

  public onBlurSelector(element: string) {
      if (element == 'div')
          this.divElementFocused = false;
      else if (element == 'input')
          this.inputElementFocused = false;

      setTimeout(() => {
          if (!this.divElementFocused && !this.inputElementFocused) {
              this._hideList();
              this.checkNoRequiredField();
          }
      },200);
  }

  public _hideList(){
    this.touched = true;
    this._displayList = 'none';
  }

  public checkNoRequiredField() {
    if (!this.allowFreeText && this.input.nativeElement.value.length > 0 && this.selectedResource == null)
      this.isInvalid = true;
    else
      this.isInvalid = false;
  }

  emitItemSelection(event,item:T) {
    this.onItemSelected.emit(item);
    this.setSelectedResource(item);
    this.checkNoRequiredField();
    this.filteredResources = this._resources;
  }

  showResourceValue(resource: T){
    if (resource[this.displayField])
      return resource[this.displayField];

    if (this.secondDisplayField && resource[this.secondDisplayField])
      return resource[this.secondDisplayField];

    return ''
  }

  public getInputValue() {
    return this.input.nativeElement.value;
  }

  public setInputValue(text: string) {
    return this.input.nativeElement.value = text;
  }
}
